type HubSpotContactResolution = "new" | "existing" | "unknown";
type Net4ContactResolution = "missing" | "existing" | "unknown";

interface AltaContactosRoutingInput {
  hubspotContact: HubSpotContactResolution;
  hasNet4Client: boolean | "unknown";
  net4Contact: Net4ContactResolution;
}

interface AltaContactosRoutingPlan {
  status: "ready" | "checking";
  createHubSpotContact: boolean;
  syncNet4: boolean;
  createNet4Contact: boolean;
}

export function resolveAltaContactosRouting(
  input: AltaContactosRoutingInput,
): AltaContactosRoutingPlan {
  if (
    input.hubspotContact === "unknown" ||
    input.hasNet4Client === "unknown" ||
    (input.hasNet4Client === true && input.net4Contact === "unknown")
  ) {
    return {
      status: "checking",
      createHubSpotContact: false,
      syncNet4: false,
      createNet4Contact: false,
    };
  }

  if (input.hubspotContact === "new") {
    return {
      status: "ready",
      createHubSpotContact: true,
      syncNet4: input.hasNet4Client === true && input.net4Contact === "missing",
      createNet4Contact: input.hasNet4Client === true && input.net4Contact === "missing",
    };
  }

  return {
    status: "ready",
    createHubSpotContact: false,
    syncNet4: input.hasNet4Client === true && input.net4Contact === "missing",
    createNet4Contact: input.hasNet4Client === true && input.net4Contact === "missing",
  };
}
